import { ThunkDispatch } from "core-integration/src/store";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getRenewableLeagues } from "core-integration/src/store/leagues/reducers";
import {
  deleteRenewableLeague,
  fetchRenewableLeagues,
  renewRenewableLeague,
} from "core-integration/src/store/leagues/thunks";
import Alert from "plos/src/components/alerts/Alert";
import { Button } from "plos/src/components/buttons/Button";
import PageTitle from "plos/src/components/PageTitle";
import Subheading from "plos/src/components/Subheading";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { rightSidebarLayout } from "plos/src/layouts";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useTrackingContext } from "../../../contexts/TrackingContext";
import HelmetHeadLeagues from "../HelmetHeadLeagues";
import { buttonWrapper, renewListStyles, renewWrapper } from "./renew.css";

const Renew = () => {
  const { t } = useTranslation("leaguesAndCups");
  const dispatch = useDispatch<ThunkDispatch>();

  const leagues = useSelector(getRenewableLeagues);
  const next = useSelector(getNextEvent);

  const { firePageViewEvent } = useTrackingContext();

  const destroy = async (id: number) =>
    await dispatch(deleteRenewableLeague(id)).catch(() => {});

  const renew = async (id: number) =>
    await dispatch(renewRenewableLeague(id)).catch(() => {});

  useEffect(() => {
    firePageViewEvent("fantasy leagues & cups", "renew league");
  }, []);

  useEffect(() => {
    const fetch = async () =>
      await dispatch(fetchRenewableLeagues()).catch(() => {});

    fetch();
  }, [dispatch]);

  return (
    <>
      <HelmetHeadLeagues />
      <div className={rightSidebarLayout}>
        <SurfaceContainer>
          <div className={renewWrapper}>
            <PageTitle title={t("renew.title", "Renew your leagues")} />
            <p>
              {t(
                "renew.description.p1",
                "Choose whether you wish to renew or delete last season's invitational leagues.",
              )}
            </p>
            <p>
              {t(
                "renew.description.p2",
                "All players from last season will automatically be entered into the renewed league(s) when they join the game.",
              )}
            </p>

            {next && leagues.length ? (
              <ul className={renewListStyles}>
                {leagues.map((l) => (
                  <li key={l.id}>
                    <Subheading>{l.name}</Subheading>
                    <div className={buttonWrapper}>
                      <Button onPress={() => renew(l.id)}>
                        {t("renew.renewButton", "Renew")}
                      </Button>
                      <Button
                        appearance="outlined"
                        onPress={() => destroy(l.id)}
                      >
                        {t("renew.deleteButton", "Delete")}
                      </Button>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <Alert isContentCentered>
                {t("renew.noLeagues", "You have no leagues to renew.")}
              </Alert>
            )}
          </div>
        </SurfaceContainer>
      </div>
    </>
  );
};

export default Renew;
